import { useSelector, useDispatch } from "react-redux";
import { useTheme } from "@mui/material";

import { showSuccessToast, showErrorToast } from "utils/toast";
import { closeTemplateModal } from "app/store/quickTextTemplates/slice/quickTextTemplateSlice";
import {
  useAddQuickTextTemplateMutation,
  useUpdateQuickTextTemplateMutation,
} from "app/store/quickTextTemplates/api/quickTextTemplateApi";
import { broadcastQuickTextTemplateData } from "utils/broadcastChannel";

const useQuickTextTemplateModal = () => {
  const { showModal, selectedTemplate, modalTitle } = useSelector(
    (state) => state.quickTextTemplate
  );

  const dispatch = useDispatch();
  const theme = useTheme();
  const [addQuickTextTemplate] = useAddQuickTextTemplateMutation();
  const [updateQuickTextTemplate] = useUpdateQuickTextTemplateMutation();

  const handleAdd = async (values) => {
    try {
      const response = await addQuickTextTemplate({
        ...values,
      }).unwrap();

      if (!response.error) {
        broadcastQuickTextTemplateData(true);
        showSuccessToast(response?.message);
      }
    } catch (error) {
      showErrorToast(error?.message || "An error occured, please try later.");
    } finally {
      broadcastQuickTextTemplateData(false);
      dispatch(
        closeTemplateModal({
          showModal: false,
        })
      );
    }
  };

  const handleUpdate = async (values) => {
    try {
      const response = await updateQuickTextTemplate({
        ...values,
        templateId: selectedTemplate?._id,
      }).unwrap();

      if (!response.error) {
        broadcastQuickTextTemplateData(true);
        showSuccessToast(response?.message);
      }
    } catch (error) {
      showErrorToast(error?.message || "An error occured, please try later.");
    } finally {
      broadcastQuickTextTemplateData(false);
      dispatch(
        closeTemplateModal({
          showModal: false,
        })
      );
    }
  };

  const onClose = () => {
    dispatch(
      closeTemplateModal({
        showModal: false,
      })
    );
  };

  return {
    showModal,
    modalTitle,
    selectedTemplate,

    onClose,
    handleAdd,
    handleUpdate,
    theme,
  };
};

export default useQuickTextTemplateModal;
